// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab.active[data-v-450b7579]{display:block}@media(max-width:767px){.tab[data-v-450b7579]{display:block}.tab+.tab[data-v-450b7579]{margin-top:1px}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
